module.exports = __webpack_public_path__ + "Love.acaf55b3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/graphics/Love.png
// module id = OZ7L
// module chunks = 0